// import { AnalysisService } from './analysis.service';
import { PanelsService } from './panels.service';
import { PricingService } from './pricing.service';
import { Injectable } from '@angular/core';
import { PwrCnt } from '../model/pwrcnt.model';
import { AnalysisService } from 'app/services/analysis.service';
import { InstallationcostService } from 'app/services/installationcost.service';
import { SubvensionService } from 'app/services/subvension.service';

/**
 * Na podstawie powierzchni dachu, naslonecznienia i rachunków miesiecznych proponuje
 * wielkosc instalacji i podaje procent zapotrzebowania.
 *
 */

@Injectable()
export class RecommendationService {
  twentyYearSavnigs = 0;

  exactPanelsPower: number;
  matchingPanelsArea: number;
  matchinPanelsPower: number;
  matchinPanelsCnt: number;
  powerCoverage: number;
  maxPanels: PwrCnt[];
  panelForCurrReq: PwrCnt[];
  maxPanelsArea: number;
  maxPanelsPower: number;

  // instalation montage cost
  instCost: number;

  constructor(
    private pricingService: PricingService,
    private panelsService: PanelsService,
    private analysisService: AnalysisService,
    private subvensionService: SubvensionService
  ) {
    this.panelForCurrReq = new Array();
    this.maxPanels = new Array();
  }

  updReccomendations() {
    this.exactPanelsPower = this.getExactPowerFor_kW();
    // reset
    this.panelForCurrReq = new Array();
    this.matchinPanelsPower = 0;
    this.matchingPanelsArea = 0;
    this.matchinPanelsCnt = 0;
    let powerToMatch = this.exactPanelsPower;
    this.panelsService.resetPanel();
    for (const rr of this.analysisService.allPolygons) {
      const pwrCnt = this.panelsService.getPanelsForPower_W(rr.area, rr.I_gr, 1000 * powerToMatch);
      if (pwrCnt.cnt === 0) { break; } // 0 means there are no matching panels
      this.matchingPanelsArea += pwrCnt.cnt * (pwrCnt.panel.l / 1000) * (pwrCnt.panel.w / 1000);
      this.matchinPanelsCnt += pwrCnt.cnt;
      this.matchinPanelsPower += pwrCnt.pwr;
      powerToMatch -= pwrCnt.pwr;
      this.panelForCurrReq.push(pwrCnt);
      if (powerToMatch < 0) { break };
    }
    console.log(this.panelForCurrReq);
    this.powerCoverage = 100 * (this.matchinPanelsPower / this.exactPanelsPower);
    // max
    this.maxPanelsArea = 0;
    this.maxPanelsPower = 0;
    this.maxPanels = new Array();
    for (const rr of this.analysisService.allPolygons) {
      const pwrCnt = this.panelsService.getPanelsForArea(rr.area);
      this.maxPanels.push(pwrCnt);
      this.maxPanelsArea += pwrCnt.cnt * (pwrCnt.panel.l / 1000) * (pwrCnt.panel.w / 1000);
      this.maxPanelsPower += pwrCnt.pwr;
    }
    console.log(this.maxPanels);
    // savings
    this.calc20YSavings();
  }

  getMatchingPanelsPower(): number {
    return this.matchinPanelsPower / 1000;
  }

  getExactPowerFor_kW(): number {
    return 12 * this.pricingService.getMonthlyPowerRequisition_kWh();
  }

  getPeakPower4CurrReq(): number {
    let pwr = 0;
    for (const pwrCnt of this.panelForCurrReq) {
      pwr += pwrCnt.panel.powerW * pwrCnt.cnt;
    }
    return pwr / 1000;
  }

  setInstallationCost(ic: number) {
    this.instCost = ic;
  }

  calc20YSavings() {
    if (this.panelForCurrReq) {
      const E_r = this.matchinPanelsPower;
      const C_e = this.pricingService.getkWhPrice_PLN();
      const E_s = 18 * E_r;
      const Q_e = this.getExactPowerFor_kW();
      const Q_es = 20 * Q_e;
      let O_20: number;
      let SP: number;
      // sprzedaż nadwyżek dla pierwszych 15 lat (liczymy 0.75 nadwyżek):
      const ndw = E_s - Q_es;
      if (Q_e <= 3000) {
        SP = 0.75 * ndw * 0.65;
      } else if (Q_e <= 10000) {
        SP = 0.75 * ndw * 0.75;
      } else { // if (Q_e > 10000)
        SP = 0.75 * ndw * 0.20;
      }
      // powyżej 15 lat (liczymy 0.25 nadwyżek)
      SP = SP + 0.25 * ndw * 0.20;
      // oszczędności 20-letnie
      if (E_s <= Q_es) {
        O_20 = C_e * E_s;
      } else {
        O_20 = C_e * Q_es + SP;
      }
      this.twentyYearSavnigs = O_20;
    }
  }

  get20ySavings(): number {
    return this.twentyYearSavnigs;
  }

  getSavings20Netto() {
    const subv = this.subvensionService.getCurrentSubvension();
    let instCost = this.instCost;
    if (subv && subv.doplata_procent > 0) {
      instCost = instCost * (100 - subv.doplata_procent) / 100;
    }
    let sv = this.get20ySavings() - instCost;
    sv = Math.ceil(sv / 10) * 10;
    return sv < 0 ? 0 : sv;
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/recommendation.service.ts